import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

    transform(bytes: number): string {
        let size = Math.floor(bytes / Math.pow(2, 20));
        if (size > 1) {
            return `${size} MB`;
        }

        size = Math.floor(bytes / Math.pow(2, 10));
        return `${size} KB`;
    }

}
